export default "__VITE_ASSET__BTER$jEy__"